import { environment } from '../environments/environment';
export class MenuConfig {
  public defaults: any = {
    aside: {
      self: {},
      items: [
        // {
        //   title: "Dashboard",
        //   root: true,
        //   icon: "dashboard",
        //   page: "/dashboard",
        //   bullet: "dot"
        // },
        {
          title: "My Rooms",
          root: true,
          icon: "room_preferences",
          page: "/rooms/directory",
          bullet: "dot"
        },
        {
          title: "My Library",
          root: true,
          icon: "widgets",
          page: "/tiles",
          bullet: "dot",
          hideInMobile: true,
          permission: [environment.customKeys.roleAdmin, environment.customKeys.roleEdit],
        },
        // {
        //   title: "StellarConnect",
        //   root: true,
        //   icon: "recent_actors",
        //   page: "/book",
        //   bullet: "dot",
        //   permission: [environment.customKeys.roleAdmin, environment.customKeys.roleEdit],
        // },
        {
          title: "Event Scheduler",
          root: true,
          icon: "calendar_month",
          page: "/event-scheduler",
          bullet: "dot",
          // fieldDisableBoolean: 'disableScheduler',
          fieldEnableBoolean: 'enableScheduler',
          permission: [environment.customKeys.roleAdmin, environment.customKeys.roleEdit]
        },
        {
          title: 'Broadcast',
          root: true,
          icon: "campaign",
          page: '/broadcast',
          bullet: "dot",
          permission: [environment.customKeys.roleAdmin, environment.customKeys.roleEdit]
        },
        {
          title: 'Admin',
          root: true,
          bullet: 'dot',
          icon: 'add',
          target: 'admin',
          hideInMobile: true,
          permission: [environment.customKeys.roleAdmin],
          submenu: [
            {
              title: 'Users',
              page: '/admin/users',
            },
            {
              title: 'Rooms',
              page: '/admin/rooms'
            },
            // {
            //   title: 'Template Layouts',
            //   page: '/admin/layouts'
            // },
            {
              title: 'Design Hub',
              page: '/rooms/settings'
            },
            {
              title: 'Billboards',
              page: '/admin/billboards'
            },
            // {
            //   title: 'Map Area',
            //   page: '/admin/maparea'
            // },
            {
              title: 'Resources',
              page: '/admin/resources'
            },
            {
              title: 'Posters',
              page: '/admin/posters'
            },
            {
              title: 'Media Library',
              page: '/admin/mediaplaylists'
            },
            {
              title: 'Image Gallery',
              page: '/admin/imagegalleries'
            },
            {
              title: 'Insights',
              page: '/admin/insights'
            },
            {
              title: 'Configurations',
              page: '/admin/configurations'
            },
          ]
        }
      ]
    },
    rside: {
      self: {},
      items: [
      ]
    }
  };

  public get configs(): any {
    return this.defaults;
  }
}
